// extracted by mini-css-extract-plugin
export var aboveInput = "_ix-0";
export var actionButton = "_ix-5";
export var actionButtonContainer = "_ix-1";
export var actionIcon = "_ix-6";
export var aiInfoContainer = "_ix-2";
export var attachmentWrapper = "_ix-7";
export var bold = "_ix-3";
export var checkIcon = "_ix-8";
export var clickingRecipientBar = "_ix-11";
export var commentThreadSwitch = "_ix-a";
export var draftImage = "_ix-b";
export var draftImageContainer = "_ix-c";
export var draftImages = "_ix-e";
export var editButton = "_ix-g";
export var editor = "_ix-f";
export var editorContainer = "_ix-y";
export var editorErrorTooltipWrapper = "_ix-9";
export var headerDivider = "_ix-h";
export var icon = "_ix-i";
export var info = "_ix-j";
export var internal = "_ix-n";
export var internalDivider = "_ix-k";
export var internalMessage = "_ix-l";
export var messageInputCard = "_ix-m";
export var messageInputForm = "_ix-o";
export var messageInputFormInternal = "_ix-p";
export var options = "_ix-q";
export var publicMessageCustomer = "_ix-s";
export var publicMessageMerchant = "_ix-r";
export var removeImageButton = "_ix-d";
export var replyButtons = "_ix-t";
export var showSignatureButton = "_ix-u";
export var spinner = "_ix-v";
export var verticalButtonDivider = "_ix-4";
export var visibilitySelector = "_ix-w";
export var warning = "_ix-x";
export var wrappingText = "_ix-z";
export var writingInternalNoteTopBorder = "_ix-10";